import React from 'react';

const CBCheckbox = ({
  label,
  checked,
  onChange, // Function called with the new boolean checked state
  name,
  id,
  disabled = false,
  className = '',
  labelClassName = '',
  inputClassName = '',
  value, // Added value prop for Checkbox.Group compatibility if needed later
  ...props
}) => {
  const handleChange = (event) => {
    if (onChange) {
      // If used in a group context, onChange might expect the event or value
      // For standalone, pass the checked state
      onChange(event.target.checked, value); // Pass value for group context
    }
  };

  const effectiveId = id || name || (value ? `${name}-${value}` : undefined);

  // Wrap input and text within the label for better click handling
  return (
    <label className={`inline-flex items-center ${className} ${labelClassName} ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
      <input
        id={effectiveId} // Keep id for potential external references, though not needed for label clicking
        name={name}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={`h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 ${inputClassName} ${disabled ? 'cursor-not-allowed opacity-50' : 'bg-white'}`}
        {...props}
      />
      {label && (
        <span className={`ml-2 block text-sm text-gray-900`}> {/* Use span for styling label text */}
          {label}
        </span>
      )}
    </label>
  );
};

// Optional: Add a Checkbox Group if needed later
// CBCheckbox.Group = ({ options = [], value = [], onChange, name, className = '', ...props }) => {
//   const handleGroupChange = (isChecked, optionValue) => {
//     let newValue;
//     if (isChecked) {
//       newValue = [...value, optionValue];
//     } else {
//       newValue = value.filter(v => v !== optionValue);
//     }
//     onChange(newValue);
//   };

//   return (
//     <div className={`flex flex-col space-y-2 ${className}`} {...props}>
//       {options.map(option => (
//         <CBCheckbox
//           key={typeof option === 'string' ? option : option.value}
//           label={typeof option === 'string' ? option : option.label}
//           value={typeof option === 'string' ? option : option.value}
//           checked={value.includes(typeof option === 'string' ? option : option.value)}
//           onChange={handleGroupChange}
//           name={name} // Group name applied to children
//         />
//       ))}
//     </div>
//   );
// };


export { CBCheckbox };